__turbopack_context__.v({
  "imageTextWrapper": "rGHCpW_imageTextWrapper",
  "text": "rGHCpW_text",
});
